import httpClient from './httpClient';

const PAGES_ENDPOINT = '/backoffice/pages';
const PAGE_WIDGETS_ENDPOINT = '/backoffice/page-widgets';
const SORT_PAGES_ENDPOINT = `${PAGES_ENDPOINT}/sort`;
const PAGES_WIDGETS_ENDPOINT = `/backoffice/page-widgets`;
const PAGES_WIDGETS_ENDPOINT_SORT = `/backoffice/page-widgets/sort`;

const getPageAPI = (id) => httpClient.get(`${PAGES_ENDPOINT}/${id}`);
const getPagesAPI = (params = {}) => httpClient.get(PAGES_ENDPOINT, { params: { ...params, type: 'static' } });
const postPageAPI = (params) => httpClient.post(PAGES_ENDPOINT, { ...params, type: 'static' });
const postSortPagesAPI = (params) => httpClient.post(SORT_PAGES_ENDPOINT, params);
const putPageAPI = (id, params) => httpClient.put(`${PAGES_ENDPOINT}/${id}`, { ...params, type: 'static' });
const deletePageAPI = (id) => httpClient.delete(`${PAGES_ENDPOINT}/${id}`);

// widgets for static page
const postPageWidgetsAPI = (params) => httpClient.post(PAGES_WIDGETS_ENDPOINT, params);
const putPageWidgetsAPI = (id, params) => httpClient.put(`${PAGES_WIDGETS_ENDPOINT}/${id}`, params);
const deletePageWidgetsAPI = (id) => httpClient.delete(`${PAGES_WIDGETS_ENDPOINT}/${id}`);
const sortPageEidgetsAPI = (params) => httpClient.post(`${PAGES_WIDGETS_ENDPOINT_SORT}`, params);
const getPageWidgetsAPI = (params) => httpClient.get(PAGE_WIDGETS_ENDPOINT, { params });


export {
	getPageAPI,
	getPagesAPI,
	postPageAPI,
	postSortPagesAPI,
	putPageAPI,
	deletePageAPI,
	getPageWidgetsAPI,
	postPageWidgetsAPI,
	putPageWidgetsAPI,
	deletePageWidgetsAPI,
	sortPageEidgetsAPI,
};
